// Section for import npm components -----------------------------------------------------------------------------------
import React, { createContext, useLayoutEffect, useState, useMemo } from 'react';
import json2mq from 'json2mq';
import useMediaQuery from '@mui/material/useMediaQuery';

// Section for import custom components --------------------------------------------------------------------------------
// @ts-ignore
import CommonUtility from '@utils/Common';
// @ts-ignore
import tailwindConfig from '../../../tailwind.config.js';

const commonUtil = CommonUtility;

// Section for type definition -----------------------------------------------------------------------------------------
export type AppConfigData = {
  appName: string;
  pathRoot: string;
  comUrl: string;
  assetUrlPrefix: string;
  appEnv: string;
  windowSize: number[];
  isMobile: boolean;
};

// @ts-ignore
const { VITE_APP_NAME, VITE_APP_ROOT_URL, VITE_APP_COM_URL, VITE_ASSET_URL_PREFIX, VITE_APP_ENV } = import.meta.env;

const AppConfigContext: React.Context<AppConfigData> = createContext<AppConfigData>({
  appName: VITE_APP_NAME.toString(),
  pathRoot: VITE_APP_ROOT_URL.toString(),
  comUrl: VITE_APP_COM_URL.toString(),
  assetUrlPrefix: VITE_ASSET_URL_PREFIX.toString(),
  appEnv: VITE_APP_ENV.toString(),
  isMobile: false,
  windowSize: [0, 0],
});

// MediaQuery settings
const matchMq: {} = {
  maxWidth: commonUtil.convertStringToNumber(tailwindConfig.theme.extend.screens.md),
};

// Section for render component ----------------------------------------------------------------------------------------
function AppConfigProvider(props: any) {
  const { children } = props;

  const [appName] = useState(VITE_APP_NAME.toString());
  const [pathRoot] = useState(VITE_APP_ROOT_URL.toString());
  const [comUrl] = useState(VITE_APP_COM_URL.toString());
  const [assetUrlPrefix] = useState(VITE_ASSET_URL_PREFIX.toString());
  const [appEnv] = useState(VITE_APP_ENV.toString());
  const [isMobile, setIsMobile] = useState(useMediaQuery(json2mq(matchMq)));
  const [windowSize, setWindowSize] = useState([0, 0]);
  const isMobileForView = useMediaQuery(json2mq(matchMq));

  useLayoutEffect(() => {
    function updateWindowSize() {
      setWindowSize([window.innerWidth, window.innerHeight]);
    }

    function updateMobileCheck() {
      setIsMobile(isMobileForView);
    }

    window.addEventListener('resize', updateWindowSize);
    updateWindowSize();

    window.addEventListener('resize', updateMobileCheck);
    updateMobileCheck();

    return () => {
      window.removeEventListener('resize', updateWindowSize);
      window.removeEventListener('resize', updateMobileCheck);
    };
  }, [isMobileForView]);

  // コンテキスト値をメモ化
  const contextValue = useMemo(
    () => ({
      appName,
      pathRoot,
      comUrl,
      assetUrlPrefix,
      appEnv,
      isMobile,
      windowSize,
    }),
    [appName, pathRoot, comUrl, assetUrlPrefix, appEnv, isMobile, windowSize],
  );

  return <AppConfigContext.Provider value={contextValue}>{children}</AppConfigContext.Provider>;
}

export { AppConfigContext };
export default AppConfigProvider;
